import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { selectSecondaryFilter, updateSecondaryFilter, selectIsSecondaryFilterClear } from './secondaryFilterSlice';
import { selectGlobalLoading } from '../../appSlice';
import MobileFilterSort from './MobileFilterSort';
import SwitchBig from '../../components/SwitchBig';
import { getImage } from '../../utilities/iconResolver';
import useHideFilter from '../../hooks/useHideFilter';
import translate from '../../utilities/translator';
import abTesting from '../../services/abTesting';
import { isMobile } from '../../utilities/helpers';
import { clearSelectedHotel } from '../search/searchSlice';
import { filterSaveClick } from '../../appSlice';
import { clearPrefetchDeals } from '../dealsList/prefetchDealsSlice';

const MultiRatesFilter = ({ sticky }) => {
  const dispatch = useDispatch();
  const ref = useRef();
  const secondaryFilter = useSelector(selectSecondaryFilter);
  const { pending, data } = secondaryFilter;
  const { luggage, flex } = data;
  const { secondaryFilterLoading } = useSelector(selectGlobalLoading);
  const [localFlexState, setLocalFlexState] = useState(flex);
  const [showModal, setShowModal] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(window.scrollY > 400);
  const isMobileView = isMobile();

  const visible = useHideFilter();
  const cls = (visible || abTesting.mobileFilterSort) ? 'visible-multi-filters' : 'hidden-filters';
  const isFilterClear = useSelector(selectIsSecondaryFilterClear);

  useEffect(() => {
    const handleScrollY = () => {
      if (showModal && window.scrollY !== 0) {
        setShowModal(false);
      }
      setIsFilterVisible(window.scrollY > 400);
    }
    if (isMobileView) {
      window.addEventListener('scroll', handleScrollY);
    }

    return () => {
      window.removeEventListener('scroll', handleScrollY);
    }
  }, [isMobileView, showModal]);

  const changeBaggage = (bagType) => {
    const newLuggage = luggage.map((item) =>
      item.value === bagType ? { ...item, active: !item.active } : item
    );
    dispatch(filterSaveClick());
    dispatch(clearPrefetchDeals());
    dispatch(
      updateSecondaryFilter({ updatedValue: newLuggage, filter: 'luggage' })
    );
    dispatch(clearSelectedHotel());
  };

  useOnClickOutside(ref, () => showModal && setShowModal(false));

  const changeFlex = () => {
    const newLocalFlexSate = {
      ...localFlexState,
      active: !localFlexState.active
    };
    dispatch(filterSaveClick());
    dispatch(clearPrefetchDeals());
    setLocalFlexState(newLocalFlexSate);
    dispatch(
      updateSecondaryFilter({ updatedValue: newLocalFlexSate, filter: 'flex' })
    );
    dispatch(clearSelectedHotel());
  };


  const bagIcon = (bagType) => {
    let imgName = '';
    if (bagType === 'canAddCib') {
      imgName = 'hf-checked-bag-new.svg';
    } else if (bagType === 'canAddTrolley') {
      imgName = 'hf-trolley-bag-new.svg';
    }
    return (<img src={getImage(imgName)} alt="" className="switcher-ico" />);
  }

  if (secondaryFilterLoading || pending) {
    return '';
  }

  return (
    <>
      <div className={classNames('multi-rates-filter-filler', { 'mrf-filler-show': ((abTesting.customizeButton && isMobile()) ? isFilterVisible : sticky) })} />
      <div
        className={classNames(`c-row multi-rates-filter-wrap pt-4 ${cls}`,
          {
            'multi-rates-filter-wrap_sticky': ((abTesting.customizeButton && isMobile()) ? isFilterVisible : sticky),
            'multi-rates-filter-wrap_static': !((abTesting.customizeButton && isMobile()) ? isFilterVisible : sticky),
            'mrf-wrap_with-customize': abTesting.customizeButton,
            'mrf-wrap_sf-set': (!isFilterClear && !abTesting.customizeButton),
            'mrf-wrap_filter-sort': abTesting.mobileFilterSort
          })}
      >
        {abTesting.mobileFilterSort ?
          <MobileFilterSort /> : (
          <div className="c-container">
            <div className="c-row">
              <div className="col-lg-12">
                <div className="multi-rates-filter" ref={ref}>
                  <div className="mrf-trigger flex justify-between items-center p-3" onClick={() => setShowModal(!showModal)}>
                    <span>{translate('holidayFinder.secondaryFilter.bookingPreferences')}</span>
                    <i className="ri-equalizer-line" />
                  </div>
                  <div className={classNames("mrf-main flex flex-col gap-2", { 'mrf-main_opened pt-3': showModal })}>
                    {luggage && luggage.length > 0 && (
                      <div className="mrf-bag-options flex gap-2">
                        {
                          luggage.map((bag, i) => (
                            <SwitchBig
                              key={i}
                              className="label-medium move-switch flex p-3 justify-between rounded-lg"
                              value={bag.active}
                              label={bag.label}
                              onChange={() => changeBaggage(bag.value)}
                              icon={bagIcon(bag.value)}
                            />
                          ))
                        }
                      </div>
                    )}
                    {flex && (
                      <SwitchBig
                        className="label-medium move-switch flex p-3 justify-between rounded-lg"
                        value={flex.active}
                        label={translate('holidayFinder.secondaryFilter.refundable')}
                        onChange={() => changeFlex()}
                        icon={<span className="switcher-ico ri-refund-2-line" />}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MultiRatesFilter;
